import * as React from 'react';
import { useSettingsContext } from '../contexts/settings';

interface IProps {
	page: number;
	maxNumPages: number;
	setPage?: (page: number) => void;
}

const LoadMore = ({ page, maxNumPages, setPage }: IProps) => {
	const { i18n } = useSettingsContext();

	if (maxNumPages > page) {
		const handleOnClick = () => {
			if (setPage) {
				setPage(page + 1);
			}
		};

		return (
			<div className="pfa-load-more">
				<button className="pfa-load-more__button" onClick={handleOnClick}>
					{i18n.showMore}
				</button>
			</div>
		);
	}

	return <></>;
};

LoadMore.displayName = 'LoadMore';

export default LoadMore;
